// Angular
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
// Transloco
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
// Store
import { Store, select } from '@ngrx/store';
import { currentUser, Logout } from '@app/core/auth';
import { AppState } from '@app/core/auth/auth.store';
// RxJs
import { Observable } from 'rxjs';
import { isEqual } from 'lodash';
// Model
import { IUserAccount, IUserCompanies } from '@app/core/auth/user.model';
// Material
import { MatDialog } from '@angular/material/dialog';
// Component
import { SwitchCompanyDialogComponent } from '../switch-company-dialog/switch-company-dialog.component';
// Module
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, RouterLink, AsyncPipe]
})
export class UserInfoComponent implements OnInit {

	// Private
	private readonly translocoService = inject(TranslocoService);
	private readonly dialog = inject(MatDialog);
	private readonly store = inject<Store<AppState>>(Store);


	// Public
	menuMode = 'light';
	profile$: Observable<IUserAccount>;
	languageChange$: Observable<string>;

	/**
	 * OnInit
	 * @memberof UserInfoComponent
	 */
	ngOnInit(): void {
		// Get User Profile
		this.profile$ = this.store.pipe(select(currentUser));
		// Get Current live language
		this.languageChange$ = this.translocoService.langChanges$;
	}

	/**
	 * On Logout
	 * @memberof UserInfoComponent
	 */
	logout(): void {
		this.store.dispatch(new Logout());
	}

	/**
	 * Open switch company access confirmation modal and pass data
	 * @returns void
	 */
	onAccessCompany(switchTo: IUserCompanies, currentCompanyName: any): void {
		if (!isEqual(currentCompanyName, switchTo.name)) {
			const info = {
				currentCompanyName,
				switchTo
			};
			this.dialog.open(SwitchCompanyDialogComponent, { data: info, panelClass: ['w-400px', 'w-md-500px'] });
		}
	}

}
